// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"e903998f","456":"2d54ce93","558":"b7900753","632":"f23146a0","907":"a80745e8"}[chunkId] + ".chunk.js";
};